module.exports = __webpack_public_path__ + "img/CL.8ee941a5.svg";